
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institucional/cookies",
      function () {
        return require("private-next-pages/institucional/cookies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institucional/cookies"])
      });
    }
  